import {
  differenceInMilliseconds,
  intervalToDuration,
  isBefore,
} from "date-fns";
import { useMemo } from "react";

import { useContinuousTime } from "~/core/hooks/use-continuous-timer";

import { useMeetingsForNext24Hours } from "./useMeetingsForNext24Hours";

export const useNextMeeting = () => {
  const { loadingMeetingsData, meetingsData } = useMeetingsForNext24Hours();
  const { continuousTime } = useContinuousTime();

  const nextMeeting = meetingsData?.[0];

  const nextMeetingStartsIn = useMemo(() => {
    if (!nextMeeting) return null;

    const meetingStartTime = new Date(nextMeeting.start_time);
    const meetingEndTime = new Date(nextMeeting.end_time);
    const timeDifference = differenceInMilliseconds(
      meetingStartTime,
      continuousTime,
    );

    const duration = intervalToDuration({
      start: 0,
      end: timeDifference,
    });

    const isMeetingEnded = isBefore(meetingEndTime, continuousTime);
    if (timeDifference <= 0 && !isMeetingEnded) return "happening now";

    if (timeDifference > 0) {
      const { days, hours, minutes, seconds } = duration;
      if (days) return `in ${days}d`;
      if (hours) return `in ${hours}h`;
      if (minutes) return `in ${minutes}m`;
      if (seconds) return `in ${seconds}s`;
    }

    return null;
  }, [continuousTime, nextMeeting]);

  return {
    nextMeeting,
    meetingsData,
    loadingMeetingsData,
    nextMeetingStartsIn,
  };
};
